import classNames from 'classnames';
import { useRive, Layout, Fit, Alignment } from '@rive-app/react-canvas';

import BackgroundImageWithLoading from '@/components/BackgroundImageWithLoading';
import { useTheme } from '@/theme';
import { pathToURL } from '@/utils/urls';

import * as styles from './styles.module.scss';

interface ProfileBackgroundProps {
    onLoad: () => void;
    classname?: string;
    imagePath?: string;
    rivUrl?: string;
}

interface ProfileBackgroundRiveProps extends ProfileBackgroundProps {
    riveUrl: string;
}

const ProfileBackgroundRive = ({ onLoad, riveUrl }: ProfileBackgroundRiveProps) => {
    const { RiveComponent } = useRive({
        src: riveUrl,
        autoplay: true,
        layout: new Layout({
            fit: Fit.Cover,
            alignment: Alignment.TopCenter,
        }),
        onLoad: () => {
            if (onLoad) {
                onLoad();
            }
        },
        stateMachines: 'State Machine 1',
    });

    return <RiveComponent key={riveUrl} />;
};

const ProfileBackground = ({ classname, onLoad, imagePath, rivUrl }: ProfileBackgroundProps) => {
    // todo handle loading when changing?
    const theme = useTheme();
    const fallbackImage = theme.customJSON.fallbackBackgroundImageUrl;
    if (!rivUrl && !fallbackImage) {
        setTimeout(() => {
            onLoad();
        }, 100);
    }
    return (
        <div className={classNames(styles.ProfileBackground, classname)}>
            {rivUrl ? (
                <ProfileBackgroundRive onLoad={onLoad} riveUrl={rivUrl} />
            ) : (
                <BackgroundImageWithLoading
                    imageUrl={imagePath ? pathToURL(imagePath) : fallbackImage}
                    onLoad={onLoad}
                />
            )}
        </div>
    );
};

export default ProfileBackground;
